module.exports = __webpack_public_path__ + "img/wqjn_icon_13.png";